var _rect, _rect2, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFr = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 27.5,
  height: 19.5,
  rx: 1.75,
  fill: "#fff",
  stroke: "#F5F5F5",
  strokeWidth: 0.5
})), /*#__PURE__*/React.createElement("mask", {
  id: "FR_svg__a",
  style: {
    maskType: "luminance"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 28,
  height: 20
}, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 27.5,
  height: 19.5,
  rx: 1.75,
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.5
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#FR_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F44653",
  d: "M18.667 0H28v20h-9.333z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 20h9.333V0H0v20Z",
  fill: "#1035BB"
}))));

export default SvgFr;